import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO,CategoryDTO, CollectionDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class collectionService implements OnInit {
    public Source:LocalDataSource;

    constructor(private http: HttpClient,private notifcationService:NotificationService) {
        this.Source = new LocalDataSource();
    }

    getCollections():any{
       return this.http.get<CollectionDTO[]>(environment.apiUrl + "/Collection")
       .pipe(
        catchError(this.handleError)

       );
    }



    addCollection(collectionDTO:CollectionDTO){
        return this.http.post(environment.apiUrl + "/Collection", collectionDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("Collection", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Collection", "ajout avec success");
                console.error(error);
            }
        );

    }

    updateCollection(Collection: CollectionDTO) {

        return this.http.put(environment.apiUrl + "/Collection", Collection).subscribe(
            data => {
                this.notifcationService.showSuccess("Collection", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Collection", "ajout avec success");
                console.error(error);
            }
        );

    }
    

    deleteCollection(idCollection:number){
        this.http.delete<any>(environment.apiUrl + "/Collection/"+idCollection).subscribe(
            data => {
                this.notifcationService.showSuccess("Collection", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Collection", "suppression avec success");
                console.error(error);
            }
        );
    }


    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };




}